var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "BuildABox" },
    [
      _c(
        "div",
        { staticClass: "build-wrapper" },
        [
          _c("div", { staticClass: "builder-content-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "builder-experience-container no-scrollbar",
                attrs: { id: "scroll-container" }
              },
              [
                _c("HeaderSteps", {
                  attrs: { currentStep: _vm.currentStep, canNext: _vm.canNext },
                  on: { "next-step": _vm.handleNextStep }
                }),
                _vm._v(" "),
                _c("HeaderActions", {
                  attrs: {
                    currentStep: _vm.currentStep,
                    currentPage: _vm.currentPage,
                    canNext: _vm.canNext,
                    selectedCardsOccasions: _vm.selectedCardsOccasions,
                    currentCopy: _vm.currentCopy,
                    currentMobileCopy: _vm.currentMobileCopy,
                    headerText: _vm.headerText
                  },
                  on: {
                    back: function($event) {
                      return _vm.changePage(false)
                    },
                    next: _vm.handleNextStep,
                    "show-filters": _vm.showFilters,
                    "show-sort": _vm.showSort,
                    "leave-builder": _vm.leaveBuilder
                  }
                }),
                _vm._v(" "),
                _vm.currentPage == 1
                  ? _c("Page3", {
                      ref: "giftsComponent",
                      on: {
                        leavebuilder: _vm.leaveBuilder,
                        changepage: function($event) {
                          return _vm.changePage($event)
                        },
                        gostep: function($event) {
                          return _vm.goStep($event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentPage == 2
                  ? _c("Page4", {
                      on: {
                        changepage: function($event) {
                          return _vm.changePage($event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentPage > 2
                  ? _c("Page5", {
                      ref: "cardComponent",
                      attrs: { currentPage: _vm.currentPage },
                      on: {
                        changepage: function($event) {
                          return _vm.changePage($event)
                        },
                        gotoaddonselection: _vm.goToAddonSelection,
                        opencart: function($event) {
                          return _vm.openCart()
                        },
                        cardwarning: function($event) {
                          return _vm.cardWarning()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("SideCartNew", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentStep > 1,
                expression: "currentStep > 1"
              }
            ],
            ref: "outSideCart",
            attrs: {
              isSticking: _vm.isSticking,
              step: _vm.currentStep,
              fromCard: _vm.fromCard
            },
            on: {
              changepage: function($event) {
                return _vm.changePage($event)
              },
              bundle: function($event) {
                return _vm.bundle($event)
              },
              gostep: function($event) {
                return _vm.goStep($event)
              },
              cardwarning: function($event) {
                return _vm.cardWarning($event)
              },
              errormodal: function($event) {
                return _vm.showErrorModal($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.selectedAddonProducts.length > 0
            ? _c("SideCartMobile", {
                ref: "sideCartMobile",
                attrs: { step: _vm.currentStep },
                on: {
                  changepage: function($event) {
                    return _vm.changePage($event)
                  },
                  bundle: _vm.bundle
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.oosIsActive
        ? _c("OOSPopUp", {
            attrs: {
              oosProducts: _vm.noStockItems,
              firstStateProducts: _vm.currentStateSelectedAddons,
              fromSavedCart: _vm.fromSavedCart,
              fromCurated: _vm.fromCurated
            },
            on: {
              goback: _vm.closeOOSPopUp,
              continuesaved: _vm.continueSaved,
              continuecurated: _vm.continueCurated
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading ? _c("div", [_vm._m(0)]) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "global-spinner-container" }, [
      _c("div", { staticClass: "global-spinner" }),
      _vm._v(" "),
      _c("p", [_vm._v("Please wait while we load your box...")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }